/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signintoupgradebanner4Inputs */

const en_signintoupgradebanner4 = /** @type {(inputs: Signintoupgradebanner4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with your existing Pulsify account to upgrade it to business.`)
};

const de_signintoupgradebanner4 = /** @type {(inputs: Signintoupgradebanner4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich mit deinem bestehenden Pulsify-Konto an, um es auf Business zu erweitern.`)
};

/**
* | output |
* | --- |
* | "Sign in with your existing Pulsify account to upgrade it to business." |
*
* @param {Signintoupgradebanner4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signintoupgradebanner4 = /** @type {((inputs?: Signintoupgradebanner4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signintoupgradebanner4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signintoupgradebanner4(inputs)
	return de_signintoupgradebanner4(inputs)
});
export { signintoupgradebanner4 as "signInToUpgradeBanner" }